import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=e19e2542"
import script from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports